var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.7775 0 19.7775 19.7775 0 19.7775"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherungsausweis-01-Overlay",
    transform: "translate(-331.000000, -56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close_Icon",
    transform: "translate(331.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fillToggle",
    d: "M19.33845,0.45375 C18.75345,-0.13125 17.80845,-0.13125 17.22345,0.45375 L9.88845,7.77375 L2.55345,0.43875 C1.96845,-0.14625 1.02345,-0.14625 0.43845,0.43875 C-0.14655,1.02375 -0.14655,1.96875 0.43845,2.55375 L7.77345,9.88875 L0.43845,17.22375 C-0.14655,17.80875 -0.14655,18.75375 0.43845,19.33875 C1.02345,19.92375 1.96845,19.92375 2.55345,19.33875 L9.88845,12.00375 L17.22345,19.33875 C17.80845,19.92375 18.75345,19.92375 19.33845,19.33875 C19.92495,18.75375 19.92495,17.80875 19.33845,17.22375 L12.00345,9.88875 L19.33845,2.55375 C19.90845,1.98375 19.90845,1.02375 19.33845,0.45375",
    id: "Fill-1",
    fill: "#F3F3F3",
    mask: "url(#mask-2)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Close_Icon.12de3433.svg";
export { ForwardRef as ReactComponent };